var pi = Math.PI,
    halfPi = pi / 2;

export function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

export function sinOut(t) {
  return Math.sin(t * halfPi);
}

export function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-ease/src/sin.js
// module id = ../../../../d3-ease/src/sin.js
// module chunks = 3